import _Reflect$construct from '@babel/runtime-corejs3/core-js/reflect/construct';
import _classCallCheck from '@babel/runtime-corejs3/helpers/classCallCheck';
import _createClass from '@babel/runtime-corejs3/helpers/createClass';
import _assertThisInitialized from '@babel/runtime-corejs3/helpers/assertThisInitialized';
import _inherits from '@babel/runtime-corejs3/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime-corejs3/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime-corejs3/helpers/getPrototypeOf';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import * as React from 'react';
import classNames from 'classnames';
import '../../../utils/fetcher.js';
import { prependPrefix } from '../../../utils/style.js';
import '@bilibili-maoer/web-utils';
import '../../utils/constants.js';
import '../../../toast/index.js';
import { filterPasswordInput } from '../../utils/validate.js';
import '@babel/runtime-corejs3/core-js/promise';
import 'lodash-es';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var EInputType;

(function (EInputType) {
  EInputType["PASSWORD"] = "password";
})(EInputType || (EInputType = {}));

var Input = /*#__PURE__*/function (_React$Component) {
  _inherits(Input, _React$Component);

  var _super = _createSuper(Input);

  function Input(props) {
    var _this;

    _classCallCheck(this, Input);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleInputChange", function (event) {
      var _this$props = _this.props,
          isFilterInput = _this$props.isFilterInput,
          onChange = _this$props.onChange;
      var value = event.target.value;

      if (!isFilterInput) {
        onChange === null || onChange === void 0 ? void 0 : onChange(value, event);

        _this.setState({
          value: value
        });

        return;
      }

      var _filterPasswordInput = filterPasswordInput(event.target),
          filteredValue = _filterPasswordInput.filteredValue,
          restoreSelectionPos = _filterPasswordInput.restoreSelectionPos;

      onChange === null || onChange === void 0 ? void 0 : onChange(filteredValue, event);

      _this.setState({
        value: filteredValue
      }, function () {
        restoreSelectionPos();
      });
    });

    _this.state = {
      value: ''
    };
    return _this;
  }

  _createClass(Input, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          error = _this$props2.error,
          icon = _this$props2.icon,
          placeholder = _this$props2.placeholder,
          type = _this$props2.type,
          value = _this$props2.value;
      return /*#__PURE__*/React.createElement("div", {
        className: classNames(prependPrefix('input'), className, _defineProperty({}, prependPrefix('error'), error))
      }, !!icon && /*#__PURE__*/React.createElement("div", {
        className: "prefix-icon"
      }, /*#__PURE__*/React.createElement("img", {
        src: icon
      })), /*#__PURE__*/React.createElement("input", {
        type: type,
        placeholder: placeholder,
        value: value || this.state.value,
        onChange: this.handleInputChange
      }), !!error && /*#__PURE__*/React.createElement("div", {
        className: "form-error-msg"
      }, error));
    }
  }]);

  return Input;
}(React.Component);

_defineProperty(Input, "defaultProps", {
  value: '',
  type: EInputType.PASSWORD
});

export { EInputType, Input };
